import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useEntities } from '@terminal/react-query-hooks/entities/useEntities';
import { useCompanyThemeCompetitors } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../../ThemeExposureTab.module.scss';
import { CompetitorCard } from '../competitor-card/CompetitorCard';

export const CompetitorsSection = ({
  entityTag,
  themeId,
  themeName,
}: {
  entityTag: string;
  themeId: string;
  themeName: string;
}) => {
  const { t } = useTranslation(['widget']);

  const { data, isError, isFetching, error } = useCompanyThemeCompetitors({
    entityTag,
    themeId,
    limit: 3,
  });
  const competitors = data?.competitors ?? [];

  const {
    data: entitiesData,
    isError: isEntitiesError,
    isLoading: isEntitiesLoading,
  } = useEntities({
    entityTags: competitors,
    enabled: !!competitors.length,
  });

  const getContent = () => {
    if (isFetching || isEntitiesLoading) {
      return (
        <SkeletonLoader
          areas={[
            { styles: { width: '100%', height: '180px', borderRadius: '8px' } },
          ]}
          data-testid="loading-skeleton"
        />
      );
    } else if (isError || isEntitiesError || !entitiesData.length) {
      return null;
    } else {
      return (
        <div
          className={sharedStyles.competitorsWrapper}
          data-testid="competitors-wrapper"
        >
          {entitiesData.map(entity => (
            <CompetitorCard entity={entity} key={entity.tag} />
          ))}
        </div>
      );
    }
  };

  if ((!isFetching && !isError && !competitors.length) || error) {
    return null;
  }

  return (
    <div className={sharedStyles.sectionRow}>
      <div className={sharedStyles.titleBase}>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.topCompetitors',
          {
            count: competitors.length,
            name: themeName,
          }
        )}
      </div>
      {getContent()}
    </div>
  );
};
